import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Whitespace, {
  WhitespaceProps,
} from '@algbra/ui/components/Whitespace/Whitespace'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { resolveAsAttachment, resolveAsImage } from '@algbra/ui/resolvers'
import { mapIndexed } from 'rambdax'

import styles from './BigFeatureBlock.module.scss'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import classNames from 'classnames'
import Heading from '@algbra/ui/components/Heading/Heading'
import { GatsbyImage } from 'gatsby-plugin-image'

export type CardItemProps = {
  id: string
  image: GatsbyResolvedAsset
  title: string
  description: string
}

export type ZoneBigFeatureBlockProps = {
  __typename: 'StrapiGQL_ComponentZonesBigFeatureBlock'
  bigFeatureTitle: string
  description: string
  image: GatsbyResolvedAsset
  cardItems: CardItemProps[]
  bigFeatureTheme: string
  whitespace: WhitespaceProps['type']
}

export function CardItem({
  image,
  title,
  description,
}: CardItemProps): JSX.Element {
  return (
    <div className={styles.card}>
      <GatsbyImage
        image={resolveAsImage(image)}
        alt={title}
        loading="lazy"
        className={styles.cardImage}
      />
      <h2>{title}</h2>
      <FreeText type="md" innerHTML={description}>
        {description}
      </FreeText>
    </div>
  )
}

export default function ZoneBigFeatureBlock({
  cardItems,
  image,
  bigFeatureTitle,
  description,
  bigFeatureTheme,
  whitespace,
}: ZoneBigFeatureBlockProps) {
  return (
    <Whitespace type={whitespace} className={styles.whiteSpace}>
      <div
        className={classNames(
          styles.bigFeatureContainer,
          styles[`theme__${bigFeatureTheme}`]
        )}
      >
        <Container>
          <Whitespace type="lg">
            <Row
              className={classNames(
                styles.container,
                styles.rowPadding,
                styles[`imageAlignment__right`]
              )}
            >
              <Column auto className={styles.contentCol}>
                <div className={styles.content}>
                  <Heading
                    type="lg"
                    className={styles.title}
                    dangerouslySetInnerHTML={{ __html: bigFeatureTitle }}
                  ></Heading>
                  <FreeText type="md" innerHTML={description}>
                    {description}
                  </FreeText>
                </div>
              </Column>
              <Column className={styles.imageCol}>
                <div className={styles.imagePlacement}>
                  <GatsbyImage
                    image={resolveAsImage(image)}
                    alt={bigFeatureTitle}
                    loading="lazy"
                    className={styles.image}
                  />
                </div>
              </Column>
            </Row>
          </Whitespace>
          {cardItems.length > 0 && (
            <div className={styles.cards}>
              {mapIndexed(
                (item: CardItemProps) => (
                  <CardItem {...item} key={item.id} />
                ),
                cardItems
              )}
            </div>
          )}
        </Container>
      </div>
    </Whitespace>
  )
}
